/* OSHA STORE — Smart predictive search enhancements. Horizon keeps the native search UI/logic. */
(function () {
  const DESKTOP_PLACEHOLDER = 'Search games, PS Plus, gift cards…  •  ابحث عن لعبة أو بلس أو كارت';
  const MOBILE_PLACEHOLDER = 'Search OSHA STORE… • ابحث هنا';
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const nativeFetch = window.fetch.bind(window);
  const FULL_SEARCH_STYLE_ID = 'osha-full-search-fixes';

  function currentPlaceholder() {
    return mobileQuery.matches ? MOBILE_PLACEHOLDER : DESKTOP_PLACEHOLDER;
  }

  function normalizeSmartQuery(value) {
    let query = (value || '').trim();
    if (!query) return query;

    /* Normalize common English/Arabic customer shorthand without changing the visible input. */
    query = query
      .replace(/\bps\s*\+/gi, 'playstation plus')
      .replace(/\bps\s*plus\b/gi, 'playstation plus')
      .replace(/\bpsplus\b/gi, 'playstation plus')
      .replace(/بلايستيشن\s*بلس/g, 'playstation plus')
      .replace(/(?:إكسترا|اكسترا)/g, 'extra')
      .replace(/بريميوم/g, 'premium')
      .replace(/(?:ديلوكس|ديلكس)/g, 'premium')
      .replace(/(?:إسينشيال|إسنشيال|اسنشيال|اسنشال)/g, 'essential')
      .replace(/(?:جيفت\s*كارد|جفت\s*كارد)/g, 'gift card')
      .replace(/(?:كارت\s*ستور|كارت\s*بلايستيشن)/g, 'gift card')
      .replace(/\bpsn\b/gi, 'playstation store gift card')
      .replace(/\s+/g, ' ')
      .trim();

    if (/^بلس$/u.test(query)) return 'playstation plus';
    if (/^بلس\s+/u.test(query)) query = query.replace(/^بلس\s+/u, 'playstation plus ');

    /* "plus", "plus 3 months", etc. should search the whole PS Plus family. */
    if (/\bplus\b/i.test(query) && !/\bplaystation\s+plus\b/i.test(query)) {
      query = query.replace(/\bplus\b/i, 'playstation plus');
    }

    /* A tier name on its own (or with a duration) should stay inside the PS Plus family. */
    if (/\b(extra|premium|essential|deluxe)\b/i.test(query) && !/\bplaystation\s+plus\b/i.test(query)) {
      query = 'playstation plus ' + query.replace(/\bdeluxe\b/gi, 'premium');
    }

    return query.replace(/\s+/g, ' ').trim();
  }

  function isPredictiveSearchUrl(url) {
    try {
      const themePath = window.Theme && Theme.routes && Theme.routes.predictive_search_url
        ? new URL(Theme.routes.predictive_search_url, location.origin).pathname
        : null;
      if (themePath && url.pathname === themePath) return true;
    } catch (error) {}

    return url.pathname.indexOf('/search/suggest') !== -1;
  }

  function isStoreSearchForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    if (!form.querySelector('input[name="q"]')) return false;

    try {
      const actionUrl = new URL(form.action || '/search', location.origin);
      const searchPath = window.Theme && Theme.routes && Theme.routes.search_url
        ? new URL(Theme.routes.search_url, location.origin).pathname
        : '/search';
      return actionUrl.pathname === searchPath;
    } catch (error) {
      return false;
    }
  }

  /*
   * Horizon's predictive-search module uses fetch under the hood. We only adjust requests
   * going to Shopify's predictive-search endpoint, leaving every other storefront request alone.
   */
  window.fetch = function (input, init) {
    try {
      const rawUrl = typeof input === 'string'
        ? input
        : input instanceof URL
          ? input.toString()
          : input instanceof Request
            ? input.url
            : String(input);

      const url = new URL(rawUrl, location.origin);

      if (isPredictiveSearchUrl(url)) {
        const originalQuery = url.searchParams.get('q');
        if (originalQuery) {
          url.searchParams.set('q', normalizeSmartQuery(originalQuery));
        }

        /* Shopify Predictive Search supports up to 10 results per resource. */
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '10');
        url.searchParams.set('resources[limit_scope]', 'each');

        if (input instanceof Request) {
          input = new Request(url.toString(), input);
        } else if (input instanceof URL) {
          input = new URL(url.toString());
        } else {
          input = url.toString();
        }
      }
    } catch (error) {
      /* Fail open: native Shopify search still runs if URL normalization ever fails. */
    }

    return nativeFetch(input, init);
  };

  /* Keep full-search submissions as smart as the live suggestions. */
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!isStoreSearchForm(form)) return;

    const input = form.querySelector('input[name="q"]');
    if (!(input instanceof HTMLInputElement)) return;

    const smartQuery = normalizeSmartQuery(input.value);
    if (!smartQuery || smartQuery === input.value.trim()) return;

    event.preventDefault();

    try {
      const url = new URL(form.action || (Theme.routes && Theme.routes.search_url) || '/search', location.origin);
      url.search = '';
      const formData = new FormData(form);

      for (const [key, value] of formData.entries()) {
        if (key === 'q') continue;
        url.searchParams.append(key, String(value));
      }

      url.searchParams.set('q', smartQuery);
      window.location.assign(url.toString());
    } catch (error) {
      /* Fail open if custom navigation ever fails. */
      input.value = smartQuery;
      form.submit();
    }
  }, true);

  function isFullSearchPage() {
    return Boolean(document.querySelector('.content-for-layout[data-template="search"]'));
  }

  function ensureFullSearchStyles() {
    if (!isFullSearchPage() || document.getElementById(FULL_SEARCH_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = FULL_SEARCH_STYLE_ID;
    style.textContent = `
      /* OSHA STORE — Search View All controls + mobile flow */
      .content-for-layout[data-template="search"] .facets-controls-wrapper,
      .content-for-layout[data-template="search"] .facets-controls-wrapper button,
      .content-for-layout[data-template="search"] .facets-controls-wrapper summary,
      .content-for-layout[data-template="search"] .facets-controls-wrapper select,
      .content-for-layout[data-template="search"] .facets-controls-wrapper .products-count-wrapper,
      .content-for-layout[data-template="search"] .facets-controls-wrapper .facets-toggle__count,
      .content-for-layout[data-template="search"] .facets-controls-wrapper .column-picker,
      .content-for-layout[data-template="search"] .facets__form-wrapper > .products-count-wrapper,
      .content-for-layout[data-template="search"] .facets__form-wrapper > .sorting-filter,
      .content-for-layout[data-template="search"] .facets__form-wrapper > .sorting-filter *,
      .content-for-layout[data-template="search"] .facets__form-wrapper .column-picker {
        color:#D6FF00!important;
        --color-foreground:#D6FF00!important;
        --color-foreground-rgb:214 255 0!important;
        --icon-opacity:1!important;
        --active-icon-opacity:1!important;
      }

      .content-for-layout[data-template="search"] .facets-controls-wrapper svg,
      .content-for-layout[data-template="search"] .facets__form-wrapper > .sorting-filter svg,
      .content-for-layout[data-template="search"] .facets__form-wrapper .column-picker svg {
        color:#D6FF00!important;
        opacity:1!important;
      }

      .content-for-layout[data-template="search"] .facets-controls-wrapper {
        border-color:rgba(214,255,0,.16)!important;
      }

      .content-for-layout[data-template="search"] .column-options__option-input:checked ~ .column-picker,
      .content-for-layout[data-template="search"] .column-picker[aria-pressed="true"] {
        color:#D6FF00!important;
        background:rgba(214,255,0,.10)!important;
        border-radius:8px!important;
      }

      .content-for-layout[data-template="search"] .sorting-filter option {
        color:#050505!important;
        background:#fff!important;
      }

      @media(max-width:749px){
        .content-for-layout[data-template="search"],
        .content-for-layout[data-template="search"] results-list,
        .content-for-layout[data-template="search"] .product-grid-container,
        .content-for-layout[data-template="search"] .collection-wrapper,
        .content-for-layout[data-template="search"] .main-collection-grid,
        .content-for-layout[data-template="search"] .product-grid {
          height:auto!important;
          min-height:0!important;
          max-height:none!important;
          overflow:visible!important;
        }

        .content-for-layout[data-template="search"] .product-grid-container {
          padding-bottom:max(48px,env(safe-area-inset-bottom))!important;
        }

        .content-for-layout[data-template="search"] .product-grid__item {
          content-visibility:visible!important;
          visibility:visible!important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function unlockFullSearchPage() {
    if (!isFullSearchPage()) return;

    /*
     * Predictive Search opens inside a scroll-locked dialog. On iOS/theme preview,
     * that root attribute can survive the View All navigation long enough to trap
     * the new results page. Remove only the stale lock on page entry; drawers opened
     * later can still create their own normal lock.
     */
    document.documentElement.removeAttribute('scroll-lock');
    ensureFullSearchStyles();
  }

  function tuneSearch(root) {
    const base = root && root.querySelectorAll ? root : document;
    base.querySelectorAll('#search-modal input.search-input, .content-for-layout[data-template="search"] .search-page-input').forEach(function (input) {
      input.setAttribute('placeholder', currentPlaceholder());
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('autocapitalize', 'off');
      input.setAttribute('spellcheck', 'false');
    });
  }

  function retunePlaceholder() {
    tuneSearch(document);
  }

  function initializeOshaSearch() {
    tuneSearch(document);
    unlockFullSearchPage();
    window.requestAnimationFrame(unlockFullSearchPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeOshaSearch, { once: true });
  } else {
    initializeOshaSearch();
  }

  window.addEventListener('pageshow', unlockFullSearchPage);

  document.addEventListener('shopify:section:load', function (event) {
    tuneSearch(event.target);
    unlockFullSearchPage();
  });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', retunePlaceholder);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(retunePlaceholder);
  }
})();
